function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
export var noop = function noop() {
  return void 0;
};
export var getMinConfigSizeList = function getMinConfigSizeList(cropConfig) {
  return cropConfig.map(function (_ref) {
    var minWidth = _ref.minWidth,
      minHeight = _ref.minHeight;
    return {
      minWidth: minWidth,
      minHeight: minHeight
    };
  });
};
export var isImageValid = function isImageValid(ops) {
  var config = ops.config,
    _ops$size = ops.size,
    width = _ops$size.width,
    height = _ops$size.height;
  var _iterator = _createForOfIteratorHelper(config),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (width >= item.minWidth && height >= item.minHeight) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
export var isImageSingleConfigMatch = function isImageSingleConfigMatch(_ref2) {
  var config = _ref2.config,
    size = _ref2.size;
  var minWidth = config.minWidth,
    maxWidth = config.maxWidth,
    minHeight = config.minHeight,
    maxHeight = config.maxHeight;
  var isExactWidth = minWidth === maxWidth;
  var isExactHeight = minHeight === maxHeight;
  var isWidthMatch = size.width >= minWidth && size.width <= maxWidth;
  var isHeightMatch = size.height >= minHeight && size.height <= maxHeight;
  if (isExactWidth && isExactHeight && isWidthMatch && isHeightMatch) {
    return true;
  }
  if (isExactWidth && isWidthMatch && isHeightMatch) {
    return true;
  }
  if (isExactHeight && isHeightMatch && isWidthMatch) {
    return true;
  }
  return false;
};
export var isImageMultipleConfigMatch = function isImageMultipleConfigMatch(_ref3) {
  var config = _ref3.config,
    size = _ref3.size;
  var _iterator2 = _createForOfIteratorHelper(config),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var isSkip = isImageSingleConfigMatch({
        config: item,
        size: size
      });
      if (isSkip) {
        return true;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};
export var getHumanSizeStr = function getHumanSizeStr(fileSizeInBytes) {
  var fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var byteUnits = 'KMGTPEZY';
  var i = -1;
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);
  return Math.max(fileSizeInBytes, 0.1).toFixed(fixed) + byteUnits.charAt(i);
};
export var validateImage = function validateImage(props) {
  var cropSizeConfig = props.cropSizeConfig,
    size = props.size;
  if (!cropSizeConfig) {
    return 'SKIP_CROP';
  }
  var isMinConfigSize = isImageValid({
    config: cropSizeConfig,
    size: size
  });
  if (!isMinConfigSize) {
    return isMinConfigSize;
  }
  if (cropSizeConfig.length === 1) {
    var item = cropSizeConfig[0];
    var isMatch = isImageSingleConfigMatch({
      config: item,
      size: size
    });
    if (isMatch) {
      return 'SKIP_CROP';
    }
  }
  var isSkip = isImageMultipleConfigMatch({
    config: cropSizeConfig,
    size: size
  });
  if (isSkip) {
    return 'SKIP_CROP';
  }
  return true;
};
export var getValidCropSize = function getValidCropSize(ops) {
  var config = ops.config,
    _ops$size2 = ops.size,
    width = _ops$size2.width,
    height = _ops$size2.height;
  if (config.length === 1) {
    return config;
  }
  var validCropSize = [];
  var _iterator3 = _createForOfIteratorHelper(config),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;
      var minWidth = item.minWidth,
        minHeight = item.minHeight;
      if (width >= minWidth && height >= minHeight) {
        validCropSize.push(item);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return validCropSize;
};
export var checkPng = function checkPng(fileType) {
  return /png/i.test(fileType);
};
export var createCropPos = function createCropPos(croppedArea, targetSize) {
  var x = croppedArea.x,
    y = croppedArea.y,
    width = croppedArea.width,
    height = croppedArea.height;
  return {
    startPosX: x,
    endPosX: x + width,
    startPosY: y,
    endPosY: y + height,
    resizeWidth: targetSize.width,
    resizeHeight: targetSize.height
  };
};
export var transVideoListItemValue = function transVideoListItemValue(item) {
  var mediaId = item.media_id,
    imageUrl = item.image_url,
    name = item.name,
    width = item.width,
    height = item.height,
    size = item.size,
    duration = item.duration;
  return {
    mediaId: mediaId,
    imageUrl: imageUrl,
    name: name,
    width: width,
    height: height,
    size: size,
    duration: Number(duration)
  };
};
export var getFormatVideoDuration = function getFormatVideoDuration(time) {
  var date = new Date(time);
  var min = String(date.getMinutes());
  var sec = String(date.getSeconds());
  return "".concat(min.padStart(2, '0'), ":").concat(sec.padStart(2, '0'));
};
export var getPageSize = function getPageSize(panelStyleConfig) {
  if (!panelStyleConfig) {
    return 15;
  }
  var panelRow = Math.round(panelStyleConfig.panelRow || 5);
  var panelCol = Math.round(panelStyleConfig.panelCol || 3);
  var col = panelCol || 5;
  var row = panelRow || 3;
  var pageSize = row * col;
  if (pageSize > 0) {
    return pageSize;
  }
  return 15;
};
export var getItemWidth = function getItemWidth(panelStyleConfig) {
  if (!panelStyleConfig) {
    return 160;
  }
  var itemWidth = Math.round(panelStyleConfig.panelItemWidth || 160);
  if (itemWidth > 0) {
    return itemWidth;
  }
  return itemWidth;
};